module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " bis ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " ausgew\xE4hlt");
  },
  "finishRangeSelectionPrompt": "Klicken, um die Auswahl des Datumsbereichs zu beenden",
  "maximumDate": "Letztes verf\xFCgbares Datum",
  "minimumDate": "Erstes verf\xFCgbares Datum",
  "next": "Weiter",
  "previous": "Zur\xFCck",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Ausgew\xE4hltes Datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Ausgew\xE4hlter Bereich: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Klicken, um die Auswahl des Datumsbereichs zu beginnen",
  "todayDate": function todayDate(args) {
    return "Heute, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Heute, ".concat(args.date, " ausgew\xE4hlt");
  }
};